import * as React from 'react'
import styled from 'styled-components'

import logoImage from '../../../images/pdftools-logo.svg'
import { containerDefault } from '../../../lib/styles/Container'
import { NavigationItem } from '../NavigationItem'
import { HeaderData } from '../types'
import { Dropdown } from './Dropdown'
import CustomLink from '../../CustomLink'
import { useI18n } from '../../../lib/context/i18n'

export interface MobileNavigationProps {
  data: HeaderData
}

const NavigationWrapper = styled.div`
  ${containerDefault}
  align-items: center;
  background: ${({ theme }) => theme.colors.white[1]};
  display: none;
  gap: 0.75rem;
  height: var(--nav-height);
  margin-inline: auto;
  position: sticky;
  top: 0;
  z-index: 100;

  @media screen and (max-width: 1080px) {
    display: flex;
  }
`

const LogoLink = styled(CustomLink)`
  display: inline-block;
  flex: 0 0 auto;
`

const Logo = styled.img`
  display: block;
  height: 1.5rem;
`

const RightNav = styled.ul`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 0.25rem;
  margin-left: auto;
`

export const MobileNavigation = ({ data }: MobileNavigationProps) => {
  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <NavigationWrapper aria-hidden="true">
      <LogoLink to="/">
        <Logo src={logoImage} alt="PDF Tools Logo" />
      </LogoLink>
      <RightNav>
        {!!data.contact_button && !!data.contact_button[0] && (
          <NavigationItem
            to={getTranslatedUrlFromLink(data.contact_button[0].link)}
            label={data.contact_button[0].label}
            $inverted
          />
        )}
        <li>
          <Dropdown data={data} />
        </li>
      </RightNav>
    </NavigationWrapper>
  )
}
